import type { Attachment, Reference } from '@medplum/fhirtypes'
import { setAttachmentConversionState } from '@seen/core/attachmentConversion'
import type { SeenMedplumClient } from '@seen/core/client'
import { detectFileType } from '#src/utils/detectFileType.ts'

export interface CreateAttachmentFromFileOptions {
  medplum: SeenMedplumClient
  securityContext?: Reference
  onProgress?: (e: ProgressEvent) => void
}

export async function createAttachmentFromFile(
  file: File,
  opts: CreateAttachmentFromFileOptions
): Promise<Attachment> {
  const { medplum, securityContext, onProgress } = opts
  const detected = await detectFileType(file)

  if (!detected.isHeic) {
    const attachment = await medplum.createAttachment({
      data: file,
      contentType: detected.mime,
      filename: detected.name,
      securityContext,
      onProgress,
    })
    return { ...attachment, size: attachment.size ?? file.size }
  }

  // HEIC path: upload raw bytes as image/heic Binary and embed pending-conversion extension
  const binary = await medplum.createBinary({
    data: file,
    contentType: 'image/heic',
    filename: detected.name,
    securityContext,
    onProgress,
  })

  const attachment: Attachment = {
    url: `Binary/${binary.id}`,
    contentType: 'image/heic',
    title: detected.name,
    size: file.size,
  }

  return setAttachmentConversionState(attachment, {
    status: 'pending',
    startedAt: new Date().toISOString(),
  })
}
